// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"205":"favorites","489":"characters","942":"not-found"}[chunkId] || chunkId) + "." + {"205":"2ce0124c","317":"41e2f46c","390":"0bd61ac0","489":"0e383cdb","942":"6f495ad2"}[chunkId] + ".js";
};